export default "__VITE_ASSET__rEYV3O1t__"